/* 各種ボタン */
interface Props {
  text: string;
  onClick: () => void;
}

const Action: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <button
      className='grid cursor-pointer place-items-center rounded border border-solid border-primary-500 bg-white py-[10px] text-sm text-primary transition-opacity hover:opacity-70'
      type='button'
      onClick={onClick}
    >
      {text}
    </button>
  );
};

const BlackOutline: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <a
      className='block cursor-pointer rounded border border-solid border-black px-6 py-3 text-center text-black transition-opacity hover:opacity-60'
      onClick={onClick}
    >
      {text}
    </a>
  );
};

const Next: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <button
      type='button'
      className='flex items-center gap-1 py-[8px] transition-opacity hover:opacity-60'
      onClick={onClick}
    >
      <span className='text-xs'>{text}</span>
      <svg
        width='12'
        height='12'
        viewBox='0 0 12 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M6.83333 6L3 2.16667L4.16667 1L9.16667 6L4.16667 11L3 9.83333L6.83333 6Z'
          fill='#292929'
        />
      </svg>
    </button>
  );
};

const Prev: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <button
      type='button'
      className='flex items-center gap-2 py-[8px] transition-opacity hover:opacity-60'
      onClick={onClick}
    >
      <svg
        width='12'
        height='12'
        viewBox='0 0 12 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M5.16667 6L9 9.83333L7.83333 11L2.83333 6L7.83333 1L9 2.16667L5.16667 6Z'
          fill='#292929'
        />
      </svg>
      <span className='text-xs'>{text}</span>
    </button>
  );
};

const PrimaryPill: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <a
      className='block cursor-pointer rounded-full bg-primary-500 px-6 py-3 text-center text-white transition-opacity hover:opacity-60'
      onClick={onClick}
    >
      {text}
    </a>
  );
};

const Primary: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <a
      className='block cursor-pointer rounded bg-primary-500 px-6 py-3 text-center text-white transition-opacity hover:opacity-60'
      onClick={onClick}
    >
      {text}
    </a>
  );
};

const PrimaryOutlinePill: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <a
      className='block cursor-pointer rounded-full border border-solid border-primary-500 px-6 py-3 text-center text-primary-500 transition-opacity hover:opacity-60'
      onClick={onClick}
    >
      {text}
    </a>
  );
};

const PrimaryOutline: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <a
      className='block cursor-pointer rounded border border-solid border-primary-500 px-6 py-3 text-center text-primary-500 transition-opacity hover:opacity-60'
      onClick={onClick}
    >
      {text}
    </a>
  );
};

const SecondaryPill: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <a
      className='block cursor-pointer rounded-full bg-warning-500 px-6 py-3 text-center text-white transition-opacity hover:opacity-60'
      onClick={onClick}
    >
      {text}
    </a>
  );
};

const SecondaryOutlinePill: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <a
      className='block rounded-full border border-solid border-warning-500 px-6 py-3 text-center text-warning-500 transition-opacity hover:opacity-60'
      onClick={onClick}
    >
      {text}
    </a>
  );
};

const SecondaryOutline: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <a
      className='block cursor-pointer rounded border border-solid border-warning px-6 py-3 text-center text-warning transition-opacity hover:opacity-60'
      onClick={onClick}
    >
      {text}
    </a>
  );
};

const TextLink: React.FC<Props> = ({ text, onClick }: Props) => {
  return (
    <button
      className='text-xs text-primary-500 underline hover:no-underline'
      type='button'
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export {
  Action,
  BlackOutline,
  Next,
  Prev,
  Primary,
  PrimaryOutline,
  PrimaryOutlinePill,
  PrimaryPill,
  SecondaryOutline,
  SecondaryOutlinePill,
  SecondaryPill,
  TextLink,
};
